import { Literal } from "runtypes";
export const WalkthroughLanguages = Literal("java").Or(Literal("kotlin").Or(Literal("python")));
export const Languages = WalkthroughLanguages.Or(Literal("any"));
//# sourceMappingURL=languages.js.map
